<div class="report-container">
	<div class="map-view">
		<div class="search">
			<div class="search-input">
				<mat-icon class="icon">search</mat-icon>
				<input #input type="search" name="search" [placeholder]="searchPlaceholder" id="search" [(ngModel)]="term" />
			</div>
		</div>
		<agm-map [zoom]="2.5" mapTypeId="roadmap" [fullscreenControl]="true" [fullscreenControl]="true">
			<agm-marker-cluster imagePath="https://raw.githubusercontent.com/googlemaps/v3-utility-library/master/markerclustererplus/images/m" *ngFor="let data of locations | filter : term">
				<agm-marker [latitude]="data.location?.latitude" [longitude]="data.location?.longitude" (mouseOver)="onMouseOver(infoWindow, $event)" (mouseOut)="onMouseOut(infoWindow, $event)" (markerClick)="locationSelected.emit(data)">
					<agm-info-window [disableAutoPan]="false" #infoWindow>
						<div class="info-window">
							<span style="padding-right: 16px">
								<b>{{ data.name }}</b>
							</span>
							<div *ngIf="reportLocationEnabled">
								<span class="mat-caption">
									{{ data.country?.name }}
								</span>
								<br />
								<span class="mat-caption">
									{{ data.tobacco_items?.length || '0' }}
									Items logged
								</span>
							</div>
						</div>
					</agm-info-window>
				</agm-marker>
			</agm-marker-cluster>
		</agm-map>
	</div>
</div>
